import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/certificate_icon.png'
import _imports_1 from '@/assets/images/total_mypage.png'
import _imports_2 from '@/assets/images/normal_mypage.png'
import _imports_3 from '@/assets/images/notice_menu_icon.png'
import _imports_4 from '@/assets/images/announce_menu_icon.png'
import _imports_5 from '@/assets/images/mypage_menu_icon.png'
import _imports_6 from '@/assets/images/data_menu_icon.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "home_top_div" }
const _hoisted_3 = { id: "mainslider" }
const _hoisted_4 = ["src", "alt", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "user_info_div"
}
const _hoisted_6 = { class: "user_info_btn_group" }
const _hoisted_7 = {
  key: 1,
  class: "mypage_info_div"
}
const _hoisted_8 = {
  key: 0,
  class: "mypage_info_img",
  src: _imports_1
}
const _hoisted_9 = {
  key: 1,
  class: "mypage_info_img",
  src: _imports_2
}
const _hoisted_10 = { class: "user_info_desc" }
const _hoisted_11 = { class: "home_main_div" }
const _hoisted_12 = { class: "home_menu_div" }
const _hoisted_13 = { class: "home_announce_div" }
const _hoisted_14 = { class: "home_announce_header" }
const _hoisted_15 = { class: "main_table_div" }
const _hoisted_16 = { class: "main_notice_ul" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "main_notice_title" }
const _hoisted_19 = { class: "main_notice_date" }
const _hoisted_20 = { class: "home_announce_div" }
const _hoisted_21 = { class: "home_announce_header" }
const _hoisted_22 = { class: "main_table_div" }
const _hoisted_23 = {
  key: 0,
  class: "no_login_div"
}
const _hoisted_24 = {
  key: 1,
  class: "no_login_div"
}
const _hoisted_25 = {
  key: 2,
  class: "main_notice_ul"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "main_notice_title" }
const _hoisted_28 = { class: "main_notice_date" }

import { onMounted, ref, computed } from "vue";
import { useRouter } from "vue-router";
import announceAPI from "@/api/announceAPI";
import loginAPI from "@/api/loginAPI";
import noticeAPI from "@/api/noticeAPI";
import { Announce, ApiResponse, Notice } from "@/common/types";
import { userStore } from "@/store/userStore";
import { convertDate } from "@/utils/utils";
import { Options, Splide, SplideSlide } from "@splidejs/vue-splide";
import { onBeforeRouteLeave } from "vue-router";
import ContractPop from "@/components/popup/ContractPop.vue";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import bannerAPI from "@/api/bannerAPI";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const store = userStore();
const router = useRouter();
const announceList = ref<Announce[]>([]);
const noticeList = ref<Notice[]>([]);

const clickData = ref<Announce>({} as Announce);
const seq = ref();
const contractFlag = ref(false);
const contractClose = () => {
  contractFlag.value = false;
};

const options: Options = {
  type: "fade",
  rewind: true,
  DragEvent: true,
  perPage: 1,
  autoplay: true,
  pauseOnHover: false,
  arrows: true,
  dots: true,
  animatedDots: true,
  direction: "ltr",
};

onBeforeRouteLeave((to, from, next) => {
  console.log(to,from,"to,from");
  // Skip the check if already navigating to certificateApproval to prevent loops
  if (to.name === 'certificateApproval') {
    next();
    return;
  }
  
  if (store.isLogin && store.userInfo.가입상태 === '신청') {
    if(to.name === "announce" || to.name === "mypage" || to.name === "resourceBoard") {    
      next({ name: "certificateApproval" });
    } else {
      next();
    }
  } else {
    next();
  }
});
onMounted(() => {
  getBanner();
  getNoticeList();
  if (store.isLogin) {
    getMainAnnounceList();
  }
});
const bannerList:any = ref([])
const getBanner = () => {
  bannerList.value = [];
  bannerAPI.getBanner().then((res) => {
    bannerList.value = res.data.data; // 전체 배너 데이터 저장
  })
}
const getNoticeList = () => {
  noticeAPI.noticeList({limit:4}).then((res) => {
    noticeList.value = res.data.data; // 전체 공지사항 데이터 저장
  });
};

const getMainAnnounceList = () => {
  announceAPI.announceList({limit:4,진행여부:true}).then((res) => {
    announceList.value = res.data.data; // 전체 공고 데이터 저장
  });
};

const goNoticeDetail = (data: Notice) => {
  router.push({ name: `noticeDetail`, params: { seq: data.공지순번 } });
};

const goAnnounceDetail = (data: Announce) => {
  
  if(store.userInfo.가입상태 === '신청') {
    alert("가입승인 후 이용하실 수 있습니다.");
    router.push({ name: "certificateApproval" });
    return;
  }
  if(!data.계약서) {
    alert("등록된 계약서가 없습니다.");
    router.push({ name: `announceDetail`, params: { seq: data.공고순번 } });
  }
  if(data.계약서[`${data.수주수행구분}계약서작성여부`]) {
    router.push({ name: `announceDetail`, params: { seq: data.공고순번 } });
  } else {
    alert("계약서 작성이 완료되지 않았습니다.");
    clickData.value = data
    seq.value = data.계약서.저장파일.저장순번
    contractFlag.value = true
  }
};

const goPage = (page: string) => {
  if (page === "announce" || page === "mypage" || page === "resourceBoard") {
    if (store.isLogin == false) {
      alert("로그인 후 이용하실 수 있습니다.");
      router.push({ name: "login" });
      return;
    } else {
      if(store.userInfo.가입상태 === '신청') {
        alert("가입승인 후 이용하실 수 있습니다.");
        router.push({ name: "certificateApproval" });
        return;
      }
      window.scrollTo({ top: 0, behavior: "auto" });
      router.push({ name: page });
      return;
    }
  }
  window.scrollTo({ top: 0, behavior: "auto" });
  router.push({ name: page });
};

const goLink = (data:any) => {
  if(data.구분 === '내부') {
    window.location.href = data.호출경로;
  } else {
    window.open(data.호출경로, "blank");
  }
};

const logout = () => {
  if (window.confirm("로그아웃 하시겠습니까?")) {
    loginAPI.logout().then(() => {
      store.logout();
      router.push({ name: "home" });
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Splide), { options: options }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannerList.value, (banner, idx) => {
                return (_openBlock(), _createBlock(_unref(SplideSlide), { key: idx }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "main_img",
                      src: `https://ptbidplus.net/member-api/api/banner/${banner.배너순번}`,
                      alt: `main${idx + 1}`,
                      onClick: ($event: any) => (goLink(banner))
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        (!_unref(store).isLogin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[10] || (_cache[10] = _createElementVNode("img", {
                class: "user_info_img",
                src: _imports_0
              }, null, -1)),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "user_info_desc" }, [
                _createTextVNode("공동인증서로"),
                _createElementVNode("br"),
                _createTextVNode("로그인 하세요")
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "main_btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goPage('login')))
                }, "로그인"),
                _createElementVNode("div", {
                  class: "main_sub_btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (goPage('signup')))
                }, "회원가입")
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_unref(store).isLogin)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : _createCommentVNode("", true),
              (_unref(store).isLogin && _unref(store).userInfo?.수주수행구분 == '수행')
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(store).userInfo.사업자명), 1),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "profile-div" }, [
                _createElementVNode("div", { class: "profile-type" }, "통합회원")
              ], -1)),
              _createElementVNode("div", {
                class: "main_btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (goPage('mypage')))
              }, "마이페이지"),
              _createElementVNode("div", null, [
                _createElementVNode("li", {
                  class: "title_menu_li",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (logout()))
                }, "로그아웃")
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "home_menu",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (goPage('notice')))
          }, _cache[13] || (_cache[13] = [
            _createElementVNode("img", {
              class: "home_menu_img",
              src: _imports_3
            }, null, -1),
            _createElementVNode("div", { class: "home_menu_label" }, "공지사항", -1)
          ])),
          _createElementVNode("div", {
            class: "home_menu",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (goPage('announce')))
          }, _cache[14] || (_cache[14] = [
            _createElementVNode("img", {
              class: "home_menu_img",
              src: _imports_4
            }, null, -1),
            _createElementVNode("div", { class: "home_menu_label" }, "공고관리", -1)
          ])),
          _createElementVNode("div", {
            class: "home_menu",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (goPage('mypage')))
          }, _cache[15] || (_cache[15] = [
            _createElementVNode("img", {
              class: "home_menu_img",
              src: _imports_5
            }, null, -1),
            _createElementVNode("div", { class: "home_menu_label" }, "마이페이지", -1)
          ])),
          _createElementVNode("div", {
            class: "home_menu",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (goPage('resourceBoard')))
          }, _cache[16] || (_cache[16] = [
            _createElementVNode("img", {
              class: "home_menu_img",
              src: _imports_6
            }, null, -1),
            _createElementVNode("div", { class: "home_menu_label" }, "자료실", -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "announce_category_tab" }, "공지사항", -1)),
            _createElementVNode("div", {
              style: {"font-size":"32px","height":"32px","line-height":"20px","margin-left":"auto","cursor":"pointer"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (goPage('notice')))
            }, "+ ")
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("ul", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeList.value, (notice, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "main_notice_li",
                  key: index,
                  onClick: ($event: any) => (goNoticeDetail(notice))
                }, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(notice.제목), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(convertDate)(notice.게시시작일)), 1)
                ], 8, _hoisted_17))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "announce_category_tab" }, "공고관리", -1)),
            (_unref(store).isLogin)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: {"font-size":"32px","height":"32px","line-height":"20px","margin-left":"auto","cursor":"pointer"},
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (goPage('announce')))
                }, "+ "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            (!_unref(store).isLogin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, "로그인을 하셔야 조회가 가능합니다."))
              : (_unref(store).userInfo.가입상태 === '신청')
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, "가입승인 후 이용하실 수 있습니다."))
                : _createCommentVNode("", true),
            (_unref(store).isLogin && _unref(store).userInfo.가입상태 !== '신청')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(announceList.value, (announce, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "main_notice_li",
                      key: index,
                      onClick: ($event: any) => (goAnnounceDetail(announce))
                    }, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(announce.공고명), 1),
                      _createElementVNode("div", _hoisted_28, _toDisplayString(announce.수행상태), 1)
                    ], 8, _hoisted_26))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (contractFlag.value)
      ? (_openBlock(), _createBlock(ContractPop, {
          key: 0,
          data: clickData.value.계약서,
          onClose: contractClose,
          seq: clickData.value.공고순번,
          seq2: seq.value,
          type: 'U'
        }, null, 8, ["data", "seq", "seq2"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})